module.exports = __webpack_public_path__ + "img/Klappläden_1.da3e07bd.jpg";